export const timeline = [
  {
    date: "08-28",
    stage: "官宣",
    title: "剧集官宣阵容，首发概念海报上线",
    desc: "片方公布主演名单与首张概念海报，讨论集中在题材与美术风格上，整体氛围偏正向。",
  },
  {
    date: "09-02",
    stage: "起势",
    title: "主海报发布，站位与字号引发第一轮讨论",
    desc: "定档主海报释出后，演员的站位顺序与名字字号被逐帧对比，社交平台出现大量截图分析。",
  },
  {
    date: "09-04",
    stage: "升温",
    title: "粉丝整理「对比图」，相关话题进入热搜",
    desc: "有网友把历年同类剧集的海报排版做成对照表，话题热度快速攀升，讨论从美术扩展到宣传公平性。",
  },
  {
    date: "09-06",
    stage: "回应",
    title: "剧方首次回应，强调「按角色权重排布」",
    desc: "片方通过官方账号说明排版依据，但并未直接回应粉丝的具体诉求，争议未见明显降温。",
  },
  {
    date: "09-09",
    stage: "转折",
    title: "主演工作室发布联合声明",
    desc: "多位主演的团队先后发声，呼吁把注意力放回作品本身，声明成为事件的重要转折点。",
  },
  {
    date: "09-11",
    stage: "降温",
    title: "剧方公布调整后的宣传物料，讨论逐步回落",
    desc: "新版物料调整了版式结构，话题热度随之下降，事件从争论转向对宣传流程的复盘总结。",
  },
];